import {
    Box,
    Button,
    Flex,
    SimpleGrid,
    Text,
    useDisclosure,
    useBreakpointValue,
  } from "@chakra-ui/react";
  import React, { useState, useEffect, useMemo } from "react";
  import TasksContainer from "../Components/TaskContainer";
  import { FaPlus, FaSpinner } from "react-icons/fa";
  import AddTaskModal from "../Components/AddTaskModal";
  import axios from "axios";
  import { DragDropContext } from "react-beautiful-dnd";
  import { useParams } from "react-router-dom";
  import { findCategory } from "../categories";
import { FORUM } from "../Theme/styles";
import { ALL_COLUMNS, columnsFor } from "../columns";
import SecretVideo from "../Components/SecretVideo";
import { useBoard } from "../useBoard";
import { API_URL } from "../config";
import { getToken } from "../token";
  
  const BoardPage = ({ onlyMine = false }) => {
    const { category: routeCategory } = useParams();
    const category = onlyMine ? null : routeCategory;
    const definition = findCategory(category);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [peoples, setPeoples] = useState([]);
    const [showHidden, setShowHidden] = useState(false);
    const columns = useMemo(
      () => (onlyMine ? ALL_COLUMNS : columnsFor(category)),
      [category, onlyMine]
    );
    const { tasks: allTasks, stan: connection } = useBoard(onlyMine ? null : category, true);

    const [mineMode, setMineMode] = useState("assigned");

    const tasks = useMemo(() => {
      if (!onlyMine) return allTasks;
      const me = localStorage.getItem("id");
      const moje = allTasks.filter((t) =>
        mineMode === "assigned"
          ? String(t.assigned_to) === String(me) || String(t.claimed_by) === String(me)
          : String(t.created_by) === String(me)
      );

      const termin = (z) => z.assignment_deadline || z.deadline || "9999-12-31";
      return [...moje].sort((a, b) => String(termin(a)).localeCompare(String(termin(b))));
    }, [allTasks, onlyMine, mineMode]);

    const postep = useMemo(() => {
      const wszystkie = tasks.length;
      if (!wszystkie) return null;
      const gotowe = tasks.filter((z) => z.status === "ukonczone").length;
      const zaczete = tasks.filter(
        (z) => z.status !== "ukonczone" && z.status !== "do_realizacji"
      ).length;
      return {
        wszystkie,
        gotowe,
        zaczete,
        czekaja: wszystkie - gotowe - zaczete,
        procent: Math.round((gotowe / wszystkie) * 100),
      };
    }, [tasks]);


    const isMobile = useBreakpointValue({ base: true, md: false });
    const [activeStatus, setWybranyStan] = useState(null);

    const visibleColumns = useMemo(() => {
      if (isMobile) {
        const selected =
          columns.find((k) => k.key === activeStatus) || columns[0];
        return [selected];
      }
      return columns.filter((k) => showHidden || !k.hiddenByDefault);
    }, [columns, showHidden, isMobile, activeStatus]);
    const schowane = columns.filter((k) => k.hiddenByDefault);
    const hiddenCount = tasks.filter((z) =>
      schowane.some((k) => k.key === z.status)
    ).length;
  
    const isDragDisabled = useBreakpointValue({ base: true, md: false });
    const buttonText = useBreakpointValue({ base: "Dodaj", md: "Dodaj nowe zadanie" });

    useEffect(() => {
      console.log('isOpen', isOpen)

    }, [isOpen])
  
    useEffect(() => {
      axios
        .get(`${API_URL}/users`, {
                withCredentials: true,
        headers: {
        'Authorization': `Bearer ${getToken()}`
        }
        })
        .then((res) => {
          setPeoples(res.data || []);
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }, []);
  
    const updateTaskStatus = async (taskId, newStatus, team) => {
      try {
        await axios.put(
          `${API_URL}/tasks/${taskId}/status`,
          { status: newStatus, team },
          {
            withCredentials: true,
            headers: { Authorization: `Bearer ${getToken()}` },
          }
        );
      } catch (e) {
        console.error("Nie udało się zmienić stanu", e);
      }
    };
  
    const onDragEnd = (result) => {
      const { destination, source, draggableId } = result;
  
      if (!destination) {
        return;
      }
  
      if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
      ) {
        return;
      }
  
      const movedTask = tasks.find((task) => String(task.id) === String(draggableId));
      if (!movedTask) return;
      updateTaskStatus(movedTask.task_id, destination.droppableId, movedTask.category);
    };
  
    return (
      <>
        {category === "gameplay" && <SecretVideo />}
        <Flex direction={"column"} h={"100%"} minH={0} gap={"4"} w={"100%"}>
          <Flex direction={"row"} gap={"4"} alignItems="center" wrap={"wrap"} flexShrink={0}>
            <Flex direction={"column"} gap={0.5}>
              <Text
                fontSize={"11px"}
                fontWeight={"500"}
                letterSpacing={"0.08em"}
                textTransform={"uppercase"}
                color={FORUM.tekstPrzygaszony}
              >
                {onlyMine ? "Przypisane do Ciebie" : "Tablica zadań"}
              </Text>
              <Text
                fontSize={"xl"}
                fontWeight={"600"}
                lineHeight={"1.1"}
                letterSpacing={"-0.01em"}
                color={FORUM.tekstJasny}
              >
                {onlyMine ? "Moje zadania" : definition?.name || category}
              </Text>
            </Flex>
            {onlyMine && (
              <Flex
                bg={FORUM.tlo}
                border={"1px solid"}
                borderColor={FORUM.obramowanie}
                borderRadius={"md"}
                p={"3px"}
                gap={"3px"}
                ml={{ base: 0, md: 4 }}
                w={{ base: "100%", md: "auto" }}
                order={{ base: 3, md: 0 }}
              >
                {[
                  { key: "assigned", label: "Przypisane do mnie" },
                  { key: "created", label: "Utworzone przeze mnie" },
                ].map((o) => (
                  <Box
                    as={"button"}
                    key={o.key}
                    px={3}
                    py={1}
                    fontSize={{ base: "xs", md: "sm" }}
                    borderRadius={"sm"}
                    whiteSpace={"nowrap"}
                    flex={{ base: 1, md: "none" }}
                    fontWeight={mineMode === o.key ? "600" : "400"}
                    color={mineMode === o.key ? FORUM.tekstJasny : FORUM.tekstPrzygaszony}
                    bg={mineMode === o.key ? FORUM.granat : "transparent"}
                    onClick={() => setMineMode(o.key)}
                  >
                    {o.label}
                  </Box>
                ))}
              </Flex>
            )}
            <Flex flex={1} />

            {postep && (
              <Flex
                direction={"column"}
                gap={1}
                minW={{ base: "100%", md: "200px" }}
                maxW={{ base: "100%", md: "260px" }}
                order={{ base: 4, md: 0 }}
                mr={{ base: 0, md: 3 }}
              >
                <Flex align={"center"} gap={2} fontSize={"11px"}>
                  <Text color={FORUM.tekstPrzygaszony}>Postęp tablicy</Text>
                  <Text color={FORUM.tekstJasny} fontWeight={"600"}>
                    {postep.procent}%
                  </Text>
                  <Box flex={1} />
                  <Text color={FORUM.tekstPrzygaszony}>
                    {postep.gotowe}/{postep.wszystkie}
                  </Text>
                </Flex>
                <Flex
                  h={"5px"}
                  borderRadius={"full"}
                  bg={FORUM.plakietka}
                  overflow={"hidden"}
                  title={`${postep.gotowe} ukończonych · ${postep.zaczete} w robocie · ${postep.czekaja} czeka`}
                >
                  <Box w={`${(postep.gotowe / postep.wszystkie) * 100}%`} bg={"#4FB477"} />
                  <Box w={`${(postep.zaczete / postep.wszystkie) * 100}%`} bg={"#E0A45C"} />
                </Flex>
              </Flex>
            )}
            {!onlyMine && <Button
              variant={"glowny"}
              size={"sm"}
              leftIcon={<FaPlus />}
              onClick={() => {
                if(isOpen) {
                  onClose()

                  setTimeout(() => {
                    onOpen()
                  }, 500)
              } else {
                onOpen()
              }
            }}
            >
              {buttonText}
            </Button>}
            {schowane.length > 0 && !isMobile && (
              <Button
                variant={"drugorzedny"}
                size={"sm"}
                onClick={() => setShowHidden((p) => !p)}
              >
                {showHidden
                  ? `Ukryj ${schowane[0].name.toLowerCase()}`
                  : `${schowane[0].name} (${hiddenCount})`}
              </Button>
            )}
            {connection !== "polaczono" && (
              <Flex align={"center"} gap={2}>
                <FaSpinner className="loading-icon" />
                <Text fontSize={"sm"} color={FORUM.tekstPrzygaszony}>
                  {connection === "wznawianie" ? "Wznawiam połączenie…" : "Łączę…"}
                </Text>
              </Flex>
            )}
          </Flex>
          {isMobile && (
            <Flex
              gap={2}
              overflowX={"auto"}
              flexShrink={0}
              pb={1}
              sx={{ "::-webkit-scrollbar": { height: "0px" } }}
            >
              {columns.map((k) => {
                const ile = tasks.filter((z) => z.status === k.key).length;
                const selected = visibleColumns[0]?.key === k.key;
                return (
                  <Flex
                    key={k.key}
                    align={"center"}
                    gap={2}
                    px={3}
                    py={2}
                    flexShrink={0}
                    borderRadius={"md"}
                    cursor={"pointer"}
                    bg={selected ? FORUM.granat : FORUM.panel}
                    color={selected ? FORUM.tekstJasny : FORUM.tekstPrzygaszony}
                    onClick={() => setWybranyStan(k.key)}
                  >
                    <Text fontSize={"sm"} fontWeight={selected ? "600" : "400"} whiteSpace={"nowrap"}>
                      {k.name}
                    </Text>
                    <Text fontSize={"xs"}>{ile}</Text>
                  </Flex>
                );
              })}
            </Flex>
          )}

          <DragDropContext onDragEnd={onDragEnd}>
            <SimpleGrid
              columns={{ base: 1, md: 2, lg: visibleColumns.length }}
              spacing={4}
              w={"100%"}
              flex={"1"}
              minH={0}
              gridTemplateRows={"minmax(0, 1fr)"}
            >
              {visibleColumns.map((k) => (
                <TasksContainer
                  key={k.key}
                  title={k.name}
                  droppableId={k.key}
                  tasks={tasks.filter((z) => z.status === k.key)}
                  peoples={peoples}
                  category={category}
                  isDragDisabled={isDragDisabled}
                  pokazKategorie={onlyMine}
                />
              ))}
            </SimpleGrid>
          </DragDropContext>
        </Flex>
        <AddTaskModal
          isOpen={isOpen}
          onClose={onClose}
          category={category}
          peoples={peoples}
        />
      </>
    );
  };
  
  export default BoardPage;
  